/**
 * I_Interpreter.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import IP_Define from 'interpreter/dev/util/IP_Define'
import IP_Util from 'interpreter/dev/util/IP_Util'
import Interpreter from 'interpreter/dev/script/IP_nativeToPseudo'; // interpreter + 추가 로직 적용
// import Interpreter from 'interpreter/dev/script/acorn_interpreter'; // interpreter (native)
// import Interpreter from 'interpreter/dev/script/class_acorn_interpreter'; // interpreter (class)
import {isDist} from "interpreter/dev/util/IP_Config";

const IP_Interpreter = (function () {

	const $ = {
		_that : undefined,
		_status : undefined,
		_isRun : undefined,
		_ip : undefined,
		_api : undefined,
		_code : undefined,
		_scope : undefined,
		_cbStep : undefined,
		_cbRun : undefined,
		_cbError : undefined,
		_prefix : undefined,
		_suffix : undefined
	};

	return class {

		/**
		 * @IP1 :: code {str}
		 * @IP2 :: scope {obj}
		 * @IP3 :: api {json}
		 * @S.E ::
		 */
		constructor(code, scope, api) {
			/*[T]*/ if (!isDist()) window.IP = this;

			// [S]
			$._that = this; // [#] 객체 캐싱
			// this._isRun = false; // [#] isRun 초기화
			this._status = IP_Define.IP_TYPE['wait']; // [#] 상태값 초기화

			if (typeof scope != 'undefined') this._scope = scope;
			if (typeof api != 'undefined') this._api = api;
			// this.init(code, scope, api); // [#] 코드 있다면, 인터프리터 인스턴스 생성

			return IP_Util.getProtected(this); // [#] 인스턴스 보호
		}

		// [V] public

		// @DES :: code {str}
		get code() { return this._code; }
		// set code(c) { this._code = c; }

		// @DES :: scope {str}
		get scope() { return JSON.parse(JSON.stringify(this._scope)); }
		// set scope(s) { this._scope = s; }

		// @DES :: api {json}
		get api() { return JSON.parse(JSON.stringify(this._api)); }
		// set api(a) { this._api = a; }

		// @DES :: status {num} - IP_Define.IP_TYPE 에서 참조하세요.
		get status() { return this._status; }
		// set status(s) { this._status = s; }

		// @DES :: isRun {bool} - 진행중인지 여부
		get isRun() { return this._isRun; }
		// set isRun(s) { this._isRun = s; }

		// @DES :: prefix {str} - 접두사
		get prefix() { return this._prefix; }
		set prefix(p) { this._prefix = p; }

		// @DES :: suffix {str} - 접미사
		get suffix() { return this._suffix; }
		set suffix(s) { this._suffix = s; }

		// @DES :: isRun {bool} - 무한반복여부
		get isRun() { return this._isRun; }
		// set isRun(ir) { this._isRun = ir; }

		// @DES :: cbError {func}
		get cbError() { return this._cbError; }
		set cbError(ce) { this._cbError = ce; }

		// @DES :: cbStep {func}
		get cbStep() { return this._cbStep; }
		set cbStep(cs) { this._cbStep = cs; }

		// @DES :: cbRun {func}
		get cbRun() { return this._cbRun; }
		set cbRun(ce) { this._cbRun = ce; }

		// [F] public

		/**
		 * @DES :: 인터프리터 실행
		 * @S.E ::
		 */
		run() {

			if (this.status == IP_Define.IP_TYPE['wait']) {
				IP_Util.print(IP_Define.MESSAGE['NO_INIT']);
				return;
			}

			if (this.status == IP_Define.IP_TYPE['step']) {
				IP_Util.print(IP_Define.MESSAGE['DO_STEP']);
				return;
			}

			// [T]
			IP_Util.print('run call');

			this._isRun = true;
			this._status =  IP_Define.IP_TYPE['step'];
			this._playStep();

		}

		/**
		 * @DES :: 인터프리터 단계 실행
		 * @S.E ::
		 */
		step() {
			IP_Util.print('step call');

			if (this.status == IP_Define.IP_TYPE['wait']) {
				IP_Util.print(IP_Define.MESSAGE['NO_INIT']);
				return;
			}

			if (this.status == IP_Define.IP_TYPE['step']) {
				IP_Util.print(IP_Define.MESSAGE['DO_STEP']);
				return;
			}

			// /*[T]*/ console.log('step call');

			this._isRun = false;
			this._status = IP_Define.IP_TYPE['step'];
			this._playStep();
		}

		/**
		 * @DES :: 인터프리터 중지
		 * @S.E :: 진행중인 스탭은 진행, isRun일 경우에만 다음 스탭 처리를 중지합니다.
		 */
		stop() {
			IP_Util.print('stop call');
			this._isRun = false;
			this._status = IP_Define.IP_TYPE['stop'];
		}

		/**
		 * @DES :: 인터프리터 초기화
		 * @S.E ::
		 */
		init(code, scope, api) {
			// if (scope) this._scope = JSON.parse(JSON.stringify(scope)); // TODO bug 있음
			if (typeof scope != 'undefined') this._scope = scope;
			// if (api) this._api = JSON.parse(JSON.stringify(api)); // TODO bug 있음
			if (typeof api != 'undefined') this._api = api;

			if (
				typeof code !== 'undefined'
				&&
				code !== null
				&&
				code !== ''
			) {
				this._code = code;
				this._ip = this._createIp(this._code);
			} else {
				IP_Util.print(IP_Define.MESSAGE['NO_CODE']); return;
			}
		}

		// [F] private

		/**
		 * @DES :: 인터프리터 생성
		 * @IP1 :: code {str}
		 * @IP2 :: scope {obj}
		 * @O.P :: interpreter {obj}
		 * @S.E ::
		 */
		_createIp(code) {
			// [T]
			// console.log('createInterpreter call');

			this._status = IP_Define.IP_TYPE['init'];
			return new Interpreter(this._addCode(code), this._initApi);
		}

		/**
		 * [Function :: _endIp]
		 *
		 * @DES :: 인터프리터 종료
		 * @S.E ::
		 */
		_endIp() {
			// /*[T]*/ console.log('_endIp call');

			this.stop();
			this._status = IP_Define.IP_TYPE['wait'];
			if (this.cbRun) this.cbRun();
		}

		/**
		 * [Function :: _playStep]
		 *
		 * @DES :: 스탭 실행
		 * @S.E :: 인터프리터 Lib를 직접 실행하는 장소
		 */
		_playStep() {
			// /*[T]*/ console.log('_playStep call', this._status);

			// [#] 스탭 진행중
			if (this._status === IP_Define.IP_TYPE['step']) {
				let moreCode;
				try {
					moreCode = this._ip.step();
					setTimeout(() => {
						this._playStep(); // [#] 재귀함수
					}, 1);
				}
				catch (e) {
					// [#] error
					if (this.cbError) this.cbError(e);
				}
				finally {
					// [#] end
					if (!moreCode) this._endIp();
				}
			}
			// [#] 스탭 종료
			else {
				// [#] step callback return & stop
				if (this.cbStep) this.cbStep();

				// [#] isRun 상태에 따라 계속 진행할지 여부를 판단합니다.
				if(
					// [1] isRun 이면 무조껀 통과
				this._isRun === true
				||
				// [2] isRun 아닌 상태에서 "stop & wait" 면 막힘
				(
					this._status !== IP_Define.IP_TYPE['wait']
					&&
					this._status !== IP_Define.IP_TYPE['stop']
				)
				) {
					this._status = IP_Define.IP_TYPE['step'];
					this._playStep(); // [#] 재귀함수
				}
			}
		}

		/**
		 * [Function :: _stopStep]
		 *
		 * @DES :: '_stopStep' 스탭 중지
		 * @S.E :: 'step'이 끝나고 '_isRun' 상태에 따라 결정
		 */
		[IP_Define.STOP_STEP_METHOD_NAME] () {
			this._status = IP_Define.IP_TYPE['stop'];
		}

		/**
		 * [Function :: _addCode]
		 *
		 * @DES :: Code 재설정 (prefix & suffix)
		 * @IP1 :: code {str}
		 * @O.P :: returnCode {str}
		 * @S.E :: 주석이면 스탭처리 하지마세요!
		 */
		_addCode(code) {
			let returnCode = '';
			let arrCode = code.trim().split("\n");

			// /*[T]*/ IP_Util.print(arrCode);

			// [#] '}', '};' => 라인으로인식 문제 해결 (뒤에서부터조회)
			for(let i=(arrCode.length-1); i>=0; i--) {
				if( arrCode[i].trim().length <= 2 ) {
					let popElement = arrCode.splice(i, 1);
					arrCode[i-1] = arrCode[i-1].trim() + popElement[0];
				}
			}

			// /*[T]*/ IP_Util.print(arrCode);

			// [#] 중단코드삽입
			arrCode.forEach((v, i) => {
				if (
					// 빈칸예외
					v.trim() !== ""
					&&
					// 주석예외
					v.trim().slice(0, 2) !== "//"
				) {
					returnCode +=
						(this.prefix ? this.prefix + '\n' : '') +
						v + '\n' +
						(this.suffix ? this.suffix + '\n' : '') +
						(i != arrCode.length - 1? IP_Define.STOP_STEP_METHOD_NAME + '();' + '\n' : '');
				}
			});

			// /*[T]*/ IP_Util.print(returnCode);

			return returnCode;
		}

		/**
		 * [Function :: _initApi]
		 *
		 * @DES :: api function init
		 * @IP1 :: ip {obj}
		 * @O.P :: scope {obj}
		 * @S.E :: 해당 함수의 scope에서 this를 사용할 수가 없습니다. 미리 선언한 그렇기 때문에 _that를 사용합니다.
		 */
		_initApi(ip, scope/*global-scope*/) {

			const NATIVE_API = $._that._api;
			const NATIVE_SCOPE = $._that._scope;

			// [#] setProperty를 이용해서 해당 스코프에 속성을 추가할 수 있습니다.

			// [#] nativeToPseudo vs pseudoToNative (README.md 참조)
			for (let key in NATIVE_SCOPE) {
				ip.setProperty(scope, key, ip.IP_nativeToPseudo(NATIVE_SCOPE[key]));
			}

			// [#] createNativeFunction vs createAsyncFunction (README.md 참조)

			// [#] STOP_STEP
			ip.setProperty(scope, IP_Define.STOP_STEP_METHOD_NAME, ip.createNativeFunction(() => {
				$._that[IP_Define.STOP_STEP_METHOD_NAME](); // [#] _stopStep()
			}));

			// [#] 해당 부분에서 추가적인 api function을 넣어줍니다.
			if (NATIVE_API) {
				for (let key in NATIVE_API) {
					// [#] 원형함수 처리 :: f
					if (NATIVE_API[key] instanceof Function) {
						ip.setProperty(scope, key, ip.createNativeFunction(NATIVE_API[key]));
					}
					// [#] 변형함수 처리 :: o => { $isAsync : b, function : f }
					else {
						// [#] IS function

						// [T]
						// console.log(key);
						// console.log(NATIVE_API[key]);
						// console.log(typeof NATIVE_API[key]);

						if (typeof NATIVE_API[key].function != 'undefined') {

							// [T]
							// console.log($._that.api[key].$isAsync);
							// console.log($._that.api[key].function);
							// console.log(NATIVE_API[key].function);

							if ($._that.api[key].$isAsync)
								ip.setProperty(scope, key, ip.createAsyncFunction(NATIVE_API[key].function));
							else
								ip.setProperty(scope, key, ip.createNativeFunction(NATIVE_API[key].function));
						}
						// [#] NO function (property)
						else {
							// TODO [PROPERTY]
							// IP_Util.print('[LC봇] init api 함수중 function 속성을 가지지 않은 개체가 있습니다.')
						}
					}
				}
			}
		}

	}
}());

export default IP_Interpreter;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/interpreter/dev/frame/IP_Interpreter.js